import React from "react";
import styles from "./SeriesFilter.module.css";

interface Series {
  _id: string;
  id: string;
  title: string;
}

interface SeriesFilterProps {
  series: Series[];
  selectedSeries: string | null;
  onChange: (seriesId: string | null) => void;
}

const SeriesFilter: React.FC<SeriesFilterProps> = ({
  series,
  selectedSeries,
  onChange,
}) => {
  const handleSeriesChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onChange(value === "all" ? null : value);
  };

  return (
    <div className={styles.seriesFilter}>
      <select
        value={selectedSeries || "all"}
        onChange={handleSeriesChange}
        className={styles.seriesSelect}
      >
        <option value="all">All Series</option>
        {series.map((seriesItem) => (
          <option key={seriesItem._id} value={seriesItem._id}>
            {seriesItem.title}
          </option>
        ))}
      </select>
      <div className={styles.selectArrow}>
        <svg viewBox="0 0 24 24">
          <path d="M7 10l5 5 5-5z" />
        </svg>
      </div>
    </div>
  );
};

export default SeriesFilter;
